export const employersDirectoryAddComponent = {
    template:`
       <employers-directory-main
       type="add"
       title="Add Company"
       >
       </employers-directory-main
    `
}


// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-add/employers-directory-add.component.js